import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getPrintReports(_, {
        query = '',
        paginate ='',
    }) {
        return axios
            .get(`/reports/print-reports${paginate}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie raportów druku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generatePrintReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/reports/print-reports?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
}
